import { CURRENCY_SYMBOL } from "../../../constant";

const ReferColumn = ({ border, title, value }) => {
  return (
    <section className="flex flex-col gap-[5px]">
      <span className="text-light-text font-medium">{title}</span>
      <span className="text-transaction-text dark:text-base-light-white text-sm font-semibold">
        {CURRENCY_SYMBOL} {value}
      </span>
      {border && (
        <div className="w-full h-[.1px] bg-base-light-white dark:bg-base-light-dark mb-[10px]"></div>
      )}
    </section>
  );
};

export default ReferColumn;
